module.exports = __webpack_public_path__ + "img/collection1.a4c7b34d.png";